import { render, staticRenderFns } from "./transaction-summary-state-tags.vue?vue&type=template&id=619cf3ba&"
import script from "./transaction-summary-state-tags.vue?vue&type=script&lang=js&"
export * from "./transaction-summary-state-tags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports